declare namespace $ {

	export class $mynamespace_myapp_button extends $mol_button_major {
	}
	
}

//# sourceMappingURL=button.view.tree.d.ts.map